module.exports = __webpack_public_path__ + "static/media/ad0lphos.b6d08b3c.jpg";